import { Flex } from "@chakra-ui/layout"
import { Button, Input, InputGroup, InputLeftAddon } from "@chakra-ui/react"
import { Select } from "@chakra-ui/select"
import React from "react"
import { useForm } from "react-hook-form"

export function Filtro({ resultado }) {
  const { register, handleSubmit, formState } = useForm()

  function onSubmit(filter) {
    console.log(filter)
    resultado(filter)
  }

  return (
    <Flex
      paddingInline={"2rem"}
      marginBlock={"2rem"}
      flexDir={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={5}
      as={"form"}
      onSubmit={handleSubmit(onSubmit)}
    >
      <Flex gap={2}>
        <InputGroup>
          <InputLeftAddon children="NFE" />
          <Input type={"number"} placeholder={"Nfe"} {...register("nfe")} />
        </InputGroup>

        <InputGroup>
          <InputLeftAddon children="N. Pedido" />
          <Input type={"number"} placeholder={"Pedido"} {...register("pedido")} />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="De" />
          <Input type={"date"} placeholder={"Data"} {...register("dataDe")} />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Ate" />
          <Input type={"date"} placeholder={"Data"} {...register("dataAte")} />
          />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Cod. Parc" />
          <Input type={"text"} placeholder={"Codigo parceiro"} {...register("codParc")} />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Pendente" />
          <Select borderLeftRadius={"0"} {...register("pendente")}>
            <option value="S">Sim</option>
            <option value="N">Não</option>
          </Select>
        </InputGroup>
      </Flex>
      <Button
        bgColor={"#378BBF"}
        width={"200px"}
        color={"white"}
        type={"submit"}
        _hover={{
          filter: "brightness(0.8)",
        }}
        isLoading={formState.isSubmitting}
        loadingText="Filtrando"
      >
        Filtrar
      </Button>
    </Flex>
  )
}
